import Salim from "./images/Salim.webp";

export const linkedinProfileLinks = [
  "https://media.licdn.com/dms/image/v2/D4D03AQEVK1axjg2caA/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1729575814759?e=2147483647&v=beta&t=gxddhR-Y_ttYzncUPGUH2mU7sSTgnGhlDDR4kBQG58Q",
  Salim,
  "",
  "https://media.licdn.com/dms/image/v2/D4E03AQFUg1H0sdcvFw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1728671157619?e=2147483647&v=beta&t=8Vkejj8w_5FZWEFgk38YR1aqLVJ9SM3jodiRo6KI5ic",
  "https://media.licdn.com/dms/image/v2/D5603AQG8NqNw8EBYDg/profile-displayphoto-scale_200_200/B56ZeEBOg7G0AY-/0/1750266605360?e=2147483647&v=beta&t=V-Z6yFK44ZgVeNfKkm_tdwpTaQTw7pHmJvgZ6TFPisA",
  "https://media.licdn.com/dms/image/v2/D4E03AQFQf-jI_WM31g/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1731668961633?e=2147483647&v=beta&t=gpJOp4nA1x55uqRFBQ4LxlrOmxS9fl7gEoET75qfCNE",
  "https://media.licdn.com/dms/image/v2/D4D03AQGJUbgJeiyLdQ/profile-displayphoto-scale_200_200/B4DaBBJZNxI8Ac-/0/1787799377440?e=2147483647&v=beta&t=E6xFJ7h6l58aStRs5LSp2S-ud81BiqSbeSlUkr2irso",
  "https://media.licdn.com/dms/image/v2/D4E03AQES6I1t3K_WDg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1731668426614?e=1792022400&v=beta&t=Fn6v8hnatfsj-25gxmj0Zdcx86vtTiPQvEXsvcl0BrY",
  "https://media.licdn.com/dms/image/v2/C4E03AQEqBLQLDSAJ0g/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1601448195935?e=1792022400&v=beta&t=d9cItLsLJE-QwIg-9GZFqee__g-fq6T8sEuiSauD0xo",
  "https://media.licdn.com/dms/image/v2/D5603AQHwM6FDRYxnjQ/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1730051292919?e=1792022400&v=beta&t=aPXaoPLb6sUoVu2gSuLYKVZtmgCcPI8LNbqZXzqfwAU",
  "https://media.licdn.com/dms/image/v2/D5603AQEoCbS2LyB4Zg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1723990389809?e=1792022400&v=beta&t=beMZrQWdtcSZxojzT5t48ojRSQsX3FTUWUDX5KmN6iE",
  "https://media.licdn.com/dms/image/v2/D5603AQF-1lwHms4fsg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1699806961893?e=1792022400&v=beta&t=CGPh--b-65aPoeMhNCPUISbz69afHiI1ewMbACiY7TM",
  "https://media.licdn.com/dms/image/v2/D5603AQFWexpPiGabqw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1723990421283?e=1792022400&v=beta&t=zPm5L5EcQBxNY-jEVNyScYPuCqcoGtOAruEUgg57YaE",
  "https://media.licdn.com/dms/image/v2/D5603AQEaJ-0T2IEfcQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1725904356230?e=1792022400&v=beta&t=iBVYaTnGnTOA1E1CGhFQ8hOEXjx7qNRVQbrBdZuZ5Zo",
  "https://media.licdn.com/dms/image/v2/D5603AQH-04-LhcN1sw/profile-displayphoto-crop_800_800/B56aBEO14NGsAM-/0/1787851137633?e=1792022400&v=beta&t=Bo5nb_ELgJeYMfxxbVVJPfmnVSg12phJKpmb1Ii40U8",
  "https://media.licdn.com/dms/image/v2/D5603AQE1E-QV_6qOhg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1730350049284?e=1792022400&v=beta&t=o2ULd8_rNmwpmTEypimBnk8HO4cEwva-aXZ70kKyno4",
  "https://media.licdn.com/dms/image/v2/D5603AQFDtILa1on7Qg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1673416180293?e=1792022400&v=beta&t=67QQa6J0hWmHLW1wDBKcmjexU9CyyXHl4DaumrnTXkw"
]

export const batchDetails = [
  "09 Nov - 08 May 2027",
  "16 Nov - 15 May 2027",
  "23 Nov - 22 May 2027",
  "30 Nov - 29 May 2027",
  "07 Dec - 05 Jun 2027",
  "14 Dec - 13 Jun 2027",
];

export const batchDetailsForExectivePG = [
  "09 Nov - 08 May 2027",
  "16 Nov - 15 May 2027",
  "23 Nov - 22 May 2027",
  "30 Nov - 29 May 2027",
  "07 Dec - 05 Jun 2027",
  "14 Dec - 13 Jun 2027",
];

export const batchDetailsForDevopsAndCloud = [
  "09 Nov - 10 Mar 2027",
  "16 Nov - 17 Mar 2027",
  "23 Nov - 24 Mar 2027",
  "30 Nov - 31 Mar 2027",
  "07 Dec - 07 Apr 2027",
  "14 Dec - 14 Apr 2027",
];

export const batchDetailsForDataScience = [
  "09 Nov - 08 May 2027",
  "16 Nov - 15 May 2027",
  "23 Nov - 22 May 2027",
  "30 Nov - 29 May 2027",
  "07 Dec - 05 Jun 2027",
  "14 Dec - 13 Jun 2027",
];
